import { IApplicationState } from '../../types/redux';
import { EPlaceholderDisabledActionType, TPlaceholderDisabledActions } from '../../actions/placeholderDisabled';

export function placeholderDisabledReducer(
  state: IApplicationState['placeholderDisabled'] = false,
  action: TPlaceholderDisabledActions,
): IApplicationState['placeholderDisabled'] {
  switch (action.type) {
    case EPlaceholderDisabledActionType.DisablePlaceholder:
      return true;
    default:
      return state;
  }
}
